import { cloneDeep } from 'lodash';
const SET_SOFT_LOGGED_IN = 'SET_SOFT_LOGGED_IN';
const SET_SOFT_LOGGED_OUT = 'SET_SOFT_LOGGED_OUT';

const initialStateSoftLoggedIn = false;

export default function reducer(state = cloneDeep(initialStateSoftLoggedIn), action ) {
	switch (action.type) {
		case SET_SOFT_LOGGED_IN:
			return true;
		case SET_SOFT_LOGGED_OUT:
			return false;
		default:
			return state;
	}
}

export function setSoftLoggedIn(){
	return { type: SET_SOFT_LOGGED_IN }
}

export function setSoftLoggedOut(){
	return { type: SET_SOFT_LOGGED_OUT }
}


// WEBPACK FOOTER //
// ./src/modules/is_soft_logged_in.js